<template>
  <li>
    <ul class="tag-type">
      <li
        v-for="(masterEmploymentStatus) in masterEmploymentStatuses"
        :key="masterEmploymentStatus.id"
      >
        <template v-if="isContainEmploymentStatus(masterEmploymentStatus.id)">
          <img
            :src="`${userOfferImageUrlForPc}/${masterEmploymentStatus.iconName}`"
            :alt="masterEmploymentStatus.name"
            :data-test="`employment-${masterEmploymentStatus.id}`"
            class="employment-img"
          >
        </template>
      </li>
    </ul>
  </li>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/search/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import * as definition from '@/lib/labelValueMappings'

export default {
  mixins: [jobPreviewCommon],
  props: {
    employmentStatus: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      masterEmploymentStatuses: definition.employmentStatuses
    }
  }
}
</script>
